import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { PopOver } from '@components/atoms/PopOver';
import styles from '../ShoppingCartTotal.module.css';
import { useData } from '@hooks/useData';

interface OrderPointsProps {
    classes?: string;
    points: number;
}

export const OrderPoints: FC<OrderPointsProps> = ({ classes, points }) => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        pointsLabel: t('shopping-cart-total-component.order-points.label'),
        pointsAmountLabel: t('shopping-cart-total-component.order-points.amount', { count: points }),
        pointsInfo: t('shopping-cart-total-component.order-points.info'),
        pointsPopoverTitle: t('shopping-cart-total-component.order-points.popover.title'),
    };

    const popoverContent = allSettings?.data?.module_points_gamification?.description;

    return (
        <>
            {points !== 0 && (
                <div className={`py-3 ${styles.indent} ${classes || ''}`} data-testid="order-points">
                    <div className="d-flex">
                        <div className="align-content-end">
                            <Typography classes="mb-0" fontSize="16">
                                <>
                                    {translations.pointsLabel}
                                    <Typography classes="ms-2" color="muted" tagVariant={TypographyTagVariants.span}>
                                        {popoverContent && (
                                            <PopOver
                                                title={translations.pointsPopoverTitle}
                                                text={popoverContent}
                                                placement="bottom">
                                                <i className="fa-light fa-circle-info"></i>
                                            </PopOver>
                                        )}
                                    </Typography>
                                </>
                            </Typography>
                        </div>
                        <div className="text-end flex-grow-1">
                            <div className="add-points d-flex align-items-center justify-content-end gap-2">
                                <i className="fa-light fa-trophy"></i>
                                <Typography classes="mb-0" fontSize="16">
                                    {translations.pointsAmountLabel}
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <Typography classes="my-1" color="muted" fontSize="12">
                        {translations.pointsInfo}
                    </Typography>
                </div>
            )}
        </>
    );
};
